import axios from "axios";

const base_url = process.env.REACT_APP_BASE_API;
const UPDATE_STATUS = process.env.REACT_APP_UPDATE_STATUS;

const apiClient = axios.create({
  baseURL: base_url,
  withCredentials: true,
});


// Intercept API responses
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // console.log("Attempting to refresh token...");
        await apiClient.post("/refresh"); // Refresh token

        return apiClient(originalRequest); // Retry failed request
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;

// API functions
export const createTransaction = async (transaction) => {
  return apiClient.post("/api/transactions/submittrans", transaction);
};

export const updateTransaction = async (id, data) => {
  return apiClient.put(`/api/transactions/updatetrans/${id}`, data);
};

export const statusChange = async (transaction) => {
  return apiClient.post(`${UPDATE_STATUS}/updatestatus`, transaction);
};

export const statusSuspend = async (id, name) => {
  return apiClient.post(`/${UPDATE_STATUS}/updatesuspend`, { id, name });
};
